// libraries.
import { useState } from "react";
import { Spinner } from "react-bootstrap";

// shared.
import { Tab } from "@shared/Tabs";
import { useUserProfile } from "@shared/GoogleLoginButton/user-slice/useUserProfile.hook";

// assets.
import { IconSummary, IconTableList } from "@assets";

// styles.
import { electricPurple600, monserratSemiBold, scarpaGray500 } from "@habitech/shared";
import { StyledTabsContainer } from "../styles";

// components.
import { ExceptionsTableTab } from "./ExceptionsTableTab";
import { RulesTableTab } from "./RulesTableTab";
import { SummaryTab } from "./SummaryTab";

// store.
import { useGetRules } from "@store/apiSlices/incentiveRules/rules.hook";

enum RulesTabEnum {
  ExceptionsTable = "exceptions-table",
  RulesTable = "rules-table",
  Summary = "summary",
}

const tabsConfig = [
  {
    tab: RulesTabEnum.ExceptionsTable,
    label: "Excepciones",
    Icon: IconTableList,
    Component: ExceptionsTableTab,
  },
  {
    tab: RulesTabEnum.RulesTable,
    label: "Reglas",
    Icon: IconTableList,
    Component: RulesTableTab,
  },
  {
    tab: RulesTabEnum.Summary,
    label: "Resumen",
    Icon: IconSummary,
    Component: SummaryTab,
  },
];

export const RulesTabs = () => {
  const [activeTab, setActiveTab] = useState<RulesTabEnum>(
    RulesTabEnum.ExceptionsTable,
  );
  const { country } = useUserProfile();
  const { isLoading, isFetching } = useGetRules(country || "CO");
  const loading = isLoading || isFetching;

  return (
    <StyledTabsContainer className="d-flex flex-column flex-grow-1 overflow-hidden">
      <div className="d-flex tabs-header flex-shrink-0">
        {tabsConfig.map(({ tab, label, Icon }) => (
          <Tab
            key={tab}
            active={activeTab === tab}
            icon={
              <Icon
                fill={activeTab === tab ? electricPurple600 : scarpaGray500}
              />
            }
            onClick={() => setActiveTab(tab)}
            title={
              <span style={{ fontFamily: monserratSemiBold, fontWeight: 600 }}>
                {label}
              </span>
            }
          />
        ))}
      </div>

      <div className="tabs-content">
        {loading ? (
          <div className="tabs-loader">
            <Spinner animation="border" variant="secondary" />
          </div>
        ) : (
          tabsConfig.map(({ tab, Component }) => (
            <div key={tab}>{activeTab === tab && <Component />}</div>
          ))
        )}
      </div>
    </StyledTabsContainer>
  );
};
